import script from "./template6.vue?vue&type=script&setup=true&lang=js"
export * from "./template6.vue?vue&type=script&setup=true&lang=js"

import "./template6.vue?vue&type=style&index=0&id=1216f006&lang=less"

const __exports__ = script;

export default __exports__